<div class="twc-container twc-m-2">
    <div class="twc-mt-1 twc-mb-3" *ngIf="subtitle">{{subtitle | translate}}</div>

    <div class="twc-row twc-col-12 twc-mb-2">
        <h3 class="twc-h3">{{'SCANPROC.DESTINATION_TITLE' | translate}}</h3>
    </div>

    <div><strong>{{'SCANPROC.DESTINATION_MSG' | translate}}</strong></div>

    <form [formGroup]="workspaceService.workspaceForm">
        <div class="twc-mt-5 twc-mb-2 twc-col-6 twc-col-sm-6">
            <div class="twc-form-element">
                <label class="twc-form-label twc-body-bold">
                    <b>{{'SCANPROC.DATASET_NAME_LABEL' | translate}}</b>
                </label>
                <input class="twc-input width-100" name="description" formControlName="newDatasetName">
            </div>
        </div>

    </form>
</div>